module.exports = __webpack_public_path__ + "img/neera-arrow.b35051ff.svg";